export enum NotificationPriority {
  LOW = "LOW",
  NORMAL = "NORMAL",
  HIGH = "HIGH",
}

export enum RequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  EVENT_CREATED = "EVENT_CREATED",
}

export interface EventRequest {
  id: string;
  title: string;
  organization?: { name: string };
  message: string;
  requestedStartDate: Date;
  requestedEndDate: Date;
  status: RequestStatus;
  rejectionReason?: string;
  createdAt: Date;
  updatedAt: Date;
  user?: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

// Status badge color mapping
export const STATUS_COLORS = {
  [RequestStatus.APPROVED]: "bg-green-500 dark:bg-green-600 text-white",
  [RequestStatus.REJECTED]: "bg-destructive text-destructive-foreground",
  [RequestStatus.CANCELLED]: "bg-muted text-muted-foreground",
  [RequestStatus.PENDING]: "bg-amber-500 dark:bg-amber-600 text-black",
  [RequestStatus.EVENT_CREATED]: "bg-slate-500 dark:bg-slate-600 text-white",
};

export interface Organization {
  id: string;
  name: string;
  address: string;
}
